import * as React from 'react';
import LoginServices from '../../../services/LoginServices';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { Redirect } from 'react-router';

/**
 * interface State (le parametre de la classe)
 */
interface State {
    /*Mail: string;
    CheckMail: boolean;
    NoMail: boolean;
    UnvalidMail: boolean;*/
    /**
     * token: le token de connection
     */
    token: string;
    /**
     * redirect: permet de rediriger vers le portail approprier
     */
    redirect: boolean;
}

/**
 * interface Props (l'état externe à la classe EmailValidation)
 */
interface Props {
    /**
     * token: le token de connection externe à la classe
     */
    token: string;
}

/**
 * Ce composant permet de mettre en place la validation d'email.
 * Il prend en paramétre (props) une string qui correspond au token et nous n'utilisons pas de service.
 */
export class EmailValidation extends React.Component {
    /** le state: l'etat interne */
    state: State;
    /** le props: l'etat externe */
    props: Props;

    /**
     * construit le formulaire de la validation de l'email
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            /*Mail: '',
            CheckMail: false,
            NoMail: false,
            UnvalidMail: false,*/
            token: this.props.token,
            redirect: false,
        };
    }

    /**
     * fait un get du token de validation et change le state avec
     * @returns {Promise<void>}
     */
    handleConfirmation = () => {
        return LoginServices.getInstance().confirmEmail(this.state.token).then(
            () => { this.setState({ redirect: true }); }
        );
    }

    /**
     * le rendu de la classe Email Validation
     * @returns {JSX.element)
     */
    render() {
        if (this.state.redirect) {
            return (<Redirect to="/" />);
        }
        return (
            <div className="col-12">
                <p className="font-weight-bold">
                    Veuillez copiez-coller le code de validation que vous avez reçu dans
                    le mail.
                </p>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Code de validation"
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState(
                                    {
                                        token: e.target.value,
                                    }
                                );
                            }
                        }
                        value={this.state.token}
                        name="token"
                        type="text"
                    />
                </div>
                <hr />
                <LoaderButton
                    className="btn btn-lg"
                    onClick={this.handleConfirmation}
                >
                    Valider
                </LoaderButton>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EmailValidationPage/internalComponents/EmailValidation.tsx